import { render } from "./goodslist.vue?vue&type=template&id=72619b7c"
import script from "./goodslist.vue?vue&type=script&lang=js"
export * from "./goodslist.vue?vue&type=script&lang=js"

import "./goodslist.vue?vue&type=style&index=0&id=72619b7c&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__